export const ONBOARDING_SUPPORT_EMAIL = "PMSOnboardingTeam@agilysys.com";

/** Shared "Need help?" block for onboarding emails (email only — no phone). */
export const buildEmailNeedHelpSection = (): string => `
                <tr>
                  <td style="padding:18px 28px;background:#f8fafc;border-top:1px solid #e2e8f0;">
                    <p style="margin:0 0 8px;font-size:14px;font-weight:700;color:#0f172a;">Need help?</p>
                    <p style="margin:0;font-size:13px;line-height:1.6;color:#475569;">
                      Email:
                      <a href="mailto:${ONBOARDING_SUPPORT_EMAIL}" style="color:#059669;text-decoration:none;font-weight:600;">
                        ${ONBOARDING_SUPPORT_EMAIL}
                      </a>
                    </p>
                  </td>
                </tr>`;
